import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, string, shape, arrayOf, bool } from 'prop-types';
import { ChevronDown } from '@magalu/stereo-ui-icons';
import { Container } from './select.styles';

function Select(_ref) {
  let {
    id,
    textLabel,
    options,
    onChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "textLabel", "options", "onChange"]);

  const selected = options.find(option => option.selected);
  return /*#__PURE__*/React.createElement(Container, props, textLabel && /*#__PURE__*/React.createElement("label", {
    htmlFor: `select-${id}`,
    "data-testid": "select-label"
  }, textLabel), /*#__PURE__*/React.createElement("select", {
    id: `select-${id}`,
    onChange: e => onChange(e.target.value),
    value: selected == null ? void 0 : selected.value,
    "data-testid": `select-${id}`
  }, options == null ? void 0 : options.map(item => /*#__PURE__*/React.createElement("option", {
    key: item.value,
    selected: item.selected,
    value: item.value,
    "data-testid": "select-option"
  }, item.label))), /*#__PURE__*/React.createElement(ChevronDown, {
    width: 20,
    height: 20
  }));
}

Select.defaultProps = {
  desktopMode: false,
  onChange: () => {},
  options: []
};
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  desktopMode: bool,
  id: string.isRequired,
  onChange: func,
  options: arrayOf(shape({
    label: string,
    value: string,
    selected: bool
  })),
  textLabel: string
} : void 0;
export default Select;